import { HttpHeaders, HttpParams } from '@angular/common/http';

export abstract class LoadCartRequest {
  public constructor(params: { [key: string]: any } = {}) {
    Object.assign(this, params);
  }

  /**
   * Gets the required HTTP headers for the load-cart request.
   */
  public getHttpHeaders(): HttpHeaders | null {
    return null;
  }

  /**
   * Build query params object for load cart url.
   *
   * @returns { HttpParams } the query params object for load cart url.
   **/
  public abstract getHttpParams(): HttpParams;
}
